import fetch from 'lib/fetch'
import deepEqual from '@f/deep-equal'

export const SAVE_INTEGRATION_SETTINGS = 'SAVE_INTEGRATION_SETTINGS'
export const SAVE_INTEGRATION_SETTINGS_ERROR = 'SAVE_INTEGRATION_SETTINGS_ERROR'
export const SAVED_INTEGRATION_SETTINGS = 'SAVED_INTEGRATION_SETTINGS'

export function saveIntegrationSettings (workspaceSlug, projectSlug, integrationName, baseData, settings) {
  const data = {
    ...baseData,
    settings
  }
  return {
    types: {
      request: SAVE_INTEGRATION_SETTINGS,
      failure: SAVE_INTEGRATION_SETTINGS_ERROR,
      receive: SAVED_INTEGRATION_SETTINGS
    },
    callAPI: () => fetch(`/api/workspaces/${workspaceSlug}/projects/${projectSlug}/integrations/${integrationName}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    }).then(res => {
      if (!res.ok) {
        const err = new Error('Unable to save integration settings')
        err.status = res.status
        throw err
      }
      return res.json()
    }),
    payload: { workspaceSlug, projectSlug, integrationName }
  }
}

export const checkAndUpdateOauthUserDataCache = (props) => (dispatch) => {
  const { userData, settings, workspaceSlug, projectSlug, baseData, integrationName } = props
  if (userData.error) return
  let shouldSaveSettings = false

  // make sure Intercom appId's are saved as top-level settings, needed for client-side
  if (userData.appId && userData.appId.length && (!settings.appId || !settings.appId.length)) {
    settings.appId = userData.appId
    shouldSaveSettings = true
  }

  // make sure cached data matches new data
  const cachedOauthDoesntMatchNew = settings.oauth && Object.keys(userData).length &&
    !deepEqual(settings.oauth, { ...settings.oauth, ...userData })
  if (cachedOauthDoesntMatchNew) {
    settings.oauth = {
      ...settings.oauth,
      ...userData
    }
    shouldSaveSettings = true
  }

  if (!shouldSaveSettings) return
  return dispatch(saveIntegrationSettings(workspaceSlug, projectSlug, integrationName, baseData, settings))
}



// WEBPACK FOOTER //
// ./actions/integration-settings.js